/*
  Constants specific to the SELECT question type. See the `types.js` file containing
  all of the possible question types for full documentation of what properties
  are allowed for each question type in the questions data file.
 */

// Required
export const OPTIONS = "options";
